module.exports = __webpack_public_path__ + "img/entertainment.5930f669.svg";